import React from "react";

import CateringItemsContent from "../components/catering/items-content.js";

const CateringItems = () => {
  return <CateringItemsContent />;
};

export default CateringItems;
